/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	
	  (0, _module.preLoad)();
	  (0, _module.toggleMenu)();
	  (0, _module.anchorLink)();
	  // footerSlider();
	  (0, _module.togglePagetop)();
	  (0, _module.resizeHeader)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width();
	
	// ------------------------------------------------------------------------
	// preLoad
	// ----- BOTH
	// ------------------------------------------------------------------------
	var preLoad = function preLoad() {
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	};
	
	// ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	var anchorLink = function anchorLink() {
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({ scrollTop: linkPosition - linkAdjust }, linkSpeed, "swing");
	    return false;
	  });
	};
	
	// ------------------------------------------------------------------------
	// footerSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	var footerSlider = function footerSlider() {
	  $('.slider-footer').slick({
	    slidesToShow: 4,
	    slidesToScroll: 1,
	    arrows: true,
	    dots: false,
	    speed: 500,
	    cssEase: 'ease',
	    centerMode: true,
	    initialSlide: 1,
	    variableWidth: true,
	    responsive: [{
	      breakpoint: 768,
	      settings: {
	        slidesToShow: 2,
	        swipe: true,
	        edgeFriction: 0.01,
	        centerMode: false,
	        initialSlide: 0
	      }
	    }]
	  });
	};
	
	// ------------------------------------------------------------------------
	// mvSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	var mvSlider = function mvSlider() {
	  $('.slider-mv').slick({
	    arrows: true,
	    dots: false,
	    infinite: true,
	    speed: 500,
	    fade: true,
	    cssEase: 'linear',
	    autoplay: true,
	    autoplaySpeed: 3000
	  });
	};
	
	// ------------------------------------------------------------------------
	// puSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	var puSlider = function puSlider() {
	  $('.slider-pickup').slick({
	    slidesToShow: 2,
	    slidesToScroll: 1,
	    arrows: true,
	    dots: true,
	    speed: 500,
	    cssEase: 'ease',
	    variableWidth: true,
	    appendArrows: '#slideNav_Wrap',
	    appendDots: '#slideNav_Dots',
	    responsive: [{
	      breakpoint: 768,
	      settings: {
	        slidesToShow: 1,
	        swipeToSlide: true,
	        swipe: true,
	        edgeFriction: 0.01
	      }
	    }]
	  });
	};
	
	// ------------------------------------------------------------------------
	// togglePagetop
	// ----- BOTH
	// ------------------------------------------------------------------------
	var togglePagetop = function togglePagetop() {
	  $(window).on("load scroll", function () {
	    var scrollHeight = $(this).scrollTop();
	    if (scrollHeight > 300) {
	      $(".st-Pagetop").addClass("visible");
	    } else {
	      $(".st-Pagetop").removeClass("visible");
	    }
	  });
	};
	
	// ------------------------------------------------------------------------
	// resizeHeader
	// ----- BOTH
	// ------------------------------------------------------------------------
	var resizeHeader = function resizeHeader() {
	  $(window).on("load scroll", function () {
	    var scrollHeight = $(this).scrollTop();
	    if (scrollHeight > 300) {
	      $(".st-Header").addClass("scrolled");
	    } else {
	      $(".st-Header").removeClass("scrolled");
	    }
	  });
	};
	
	// ------------------------------------------------------------------------
	// comicSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	var comicSlider = function comicSlider() {
	  $('.slider-comic').slick({
	    arrows: false,
	    dots: true,
	    infinite: true,
	    speed: 500,
	    fade: true,
	    cssEase: 'ease',
	    customPaging: function customPaging(slick, index) {
	      var targetImage = slick.$slides.eq(index).find('.img').attr('data-src');
	      return '<button style="background:url(' + targetImage + ') no-repeat center center/contain"/>';
	    }
	  });
	};
	
	// ------------------------------------------------------------------------
	// goodsSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	var goodsSlider = function goodsSlider() {
	  var $slide = $('.slider-goods');
	  $slide.on('init', function (event, slick) {
	    $.extend(slick, { clonedSlides: $(this).find('.slick-cloned') });
	  });
	  $slide.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
	    slick.clonedSlides.addClass('slick-current-clone');
	  });
	  $slide.on('afterChange', function (event, slick, currentSlide) {
	    slick.clonedSlides.removeClass('slick-current-clone');
	  });
	  $slide.slick({
	    infinite: false,
	    autoplay: false,
	    speed: 1000,
	    slidesToShow: 1,
	    centerMode: true,
	    variableWidth: true,
	    focusOnSelect: true,
	    dots: true,
	    appendArrows: '#slideNav_Wrap',
	    appendDots: '#slideNav_Dots',
	    responsive: [{
	      breakpoint: 768,
	      settings: {
	        slidesToShow: 1
	      }
	    }]
	  });
	};
	
	// ------------------------------------------------------------------------
	// toggleMenu
	// ----- BOTH
	// ------------------------------------------------------------------------
	var toggleMenu = function toggleMenu() {
	  $('.st-Header .hamburger button').on('click', function () {
	    $(this).toggleClass("open");
	    $(".st-Header nav").toggleClass("open");
	    $(".st-Header_Inner").toggleClass("open");
	  });
	};
	
	// ------------------------------------------------------------------------
	// scrollAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	var scrollAnime = function scrollAnime() {
	  $(window).on('scroll load', function () {
	    $('.js-anim').each(function () {
	      var targetPos = $(this).offset().top;
	      var scrollPos = $(window).scrollTop();
	      var windowHeight = $(window).height();
	      if (scrollPos > targetPos - windowHeight + windowHeight / 8) {
	        $(this).addClass("animated");
	      }
	    });
	  });
	};
	
	// ------------------------------------------------------------------------
	// popupImage
	// ----- BOTH
	// ------------------------------------------------------------------------
	var popupImage = function popupImage() {
	  var trg = 0;
	  $('.popup-toggle').on('click', function () {
	    trg = 1;
	    var source = $(this).data('source');
	    $('.sw-Popup_Box_Inner').children('img').attr('src', source);
	    $(".sw-Popup").toggleClass("open");
	  });
	  $('.sw-Popup_Close , .sw-Popup_Base').on('click', function () {
	    trg = 0;
	    $(".popup-toggle").toggleClass("open");
	    $(".sw-Popup").toggleClass("open");
	    setTimeout(function () {
	      $('.sw-Popup_Box_Inner').children('img').attr('src', '');
	    }, 500);
	  });
	  $(window).on('scroll', function () {
	    if (trg == 1) {
	      trg = 0;
	      $(".popup-toggle").toggleClass("open");
	      $(".sw-Popup").toggleClass("open");
	      setTimeout(function () {
	        $('.sw-Popup_Box_Inner').children('img').attr('src', '');
	      }, 500);
	    }
	  });
	};
	
	exports.preLoad = preLoad;
	exports.anchorLink = anchorLink;
	exports.mvSlider = mvSlider;
	exports.puSlider = puSlider;
	exports.footerSlider = footerSlider;
	exports.togglePagetop = togglePagetop;
	exports.resizeHeader = resizeHeader;
	exports.comicSlider = comicSlider;
	exports.goodsSlider = goodsSlider;
	exports.toggleMenu = toggleMenu;
	exports.scrollAnime = scrollAnime;
	exports.popupImage = popupImage;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common/common.bundle.js